import "./suppressResizeObserverError";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initTheme } from "@archlang/app-shell/theme";
import { initStudioLocale } from "./i18n";
import { AppRouter } from "./app/router";
import "./styles/globals.css";

initTheme();
initStudioLocale();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
